"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeplrError = void 0;
class KeplrError extends Error {
    constructor(module, code, message) {
        super(message);
        this.module = module;
        this.code = code;
        Object.setPrototypeOf(this, KeplrError.prototype);
    }
}
exports.KeplrError = KeplrError;
//# sourceMappingURL=error.js.map